import { schemaDocumentSnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '../../schema'

export const promotion = (promotionId: string) =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['promotions', promotionId],
    factory: collections.promotions,
    id: promotionId,
  })
